import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import "./Terms_of_Service.css"; // Import CSS file

const Terms_Of_Service = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/terms.md")
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="terms-container">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default Terms_Of_Service;
